import * as z from 'zod';

// Types
import { blocksSchemaZod } from '@/components/blocks/Blocks';
import { SeoZod } from '@/types/SeoType';

export const PageZod = z.object({
  id: z.number(),
  documentId: z.string(),
  slug: z.string(),
  blocks: z.array(blocksSchemaZod),
  seo: SeoZod,
});

export type PageType = z.infer<typeof PageZod>;

export const PageSlugZod = PageZod.pick({
  id: true,
  documentId: true,
  slug: true,
  seo: true,
});

export type PageSlugType = z.infer<typeof PageSlugZod>;
